import { createSlice, current } from '@reduxjs/toolkit'
import { toast } from 'react-toastify';
import { ServiceEngine } from "../../../Services/ServiceEngine";
import update from 'react-addons-update';

import {
    HTTP_STATUS_CODE_401_UNAUTHORIZED,
    HTTP_STATUS_CODE_403_FORBIDDEN,
    ERROR_MESSAGE_401_UNAUTHORIZED,
    ERROR_MESSAGE_403_FORBIDDEN,
    UPDATE_SIMULATION_ENDPOINT,
    STOP_SIMULATION_ENDPOINT,
    START_SIMULATION_ENDPOINT,
} from "../../../Configs";

export const SimulationServicesSlice = createSlice({
    name: 'simulation',
    initialState: {
        TransactionSequence: [],
        CurrentTransaction:null
    },
    reducers: {
        AddTransactionToSequence: (state, action) => {
            let newTransaction = action.payload;
            return {
                ...state,
                TransactionSequence: [...state.TransactionSequence, newTransaction]
            };
        },
        UpdateTransactionSequence: (state, action) => {
            let updatedTransaction = action.payload;
            var existingSequence = current(state).TransactionSequence
            const updatedSequence = existingSequence.map(sequence => {
                if (updatedTransaction.identifier == sequence.identifier) {
                    let updatedSequenceObj = update(sequence, {
                        $merge: updatedTransaction
                    })
                    return updatedSequenceObj;
                } else {
                    return sequence;
                }
            });
            return {
                ...state,
                TransactionSequence: updatedSequence
            };
        },
        SetCurrentTransaction: (state, action) => {
            let transaction = action.payload;
            return {
                ...state,
                CurrentTransaction: transaction
            };
        },
        UpdateCurrentTransaction: (state, action) => {
            let transaction = action.payload;
            return {
                ...state,
                CurrentTransaction: transaction
            };
        },
        UnsetCurrentTransaction: (state, action) => {
            return {
                ...state,
                CurrentTransaction: null
            };
        },
    },
})

export const {
    AddTransactionToSequence,
    UpdateTransactionSequence,
    SetCurrentTransaction,
    UpdateCurrentTransaction,
    UnsetCurrentTransaction
} = SimulationServicesSlice.actions

export const AddSequence = (payload) => (dispatch) => {
    dispatch(AddTransactionToSequence(payload))
}

export const UpdateSequence = (payload) => (dispatch) => {
    dispatch(UpdateTransactionSequence(payload))
}

export const SetTransaction = (payload) => (dispatch) => {
    dispatch(SetCurrentTransaction(payload))
}

export const UnsetTransaction = () => (dispatch) => {
    dispatch(UnsetCurrentTransaction())
}

export const UpdateTransaction = (payload) => (dispatch) => {
    dispatch(UpdateCurrentTransaction(payload))
}

export const UpdateSimulation = (payload, callback) => (dispatch) => {
    ServiceEngine.put(UPDATE_SIMULATION_ENDPOINT, payload).then(response => {
        callback(response.data, true);
    }).catch(
        error => {
            if (error.response !== undefined) {
                if (HTTP_STATUS_CODE_401_UNAUTHORIZED === error.response.status) {
                    toast.error(ERROR_MESSAGE_401_UNAUTHORIZED)
                } else if (HTTP_STATUS_CODE_403_FORBIDDEN === error.response.status) {
                    toast.error(ERROR_MESSAGE_403_FORBIDDEN)
                } else {
                    //error.response.data
                }
            } else {
                toast.error("Check your internet connection or network connectivity issue between servers");
            }
            callback(null, false);
        })
}

export const StopSimulation = (callback) => (dispatch) => {
    ServiceEngine.delete(STOP_SIMULATION_ENDPOINT).then(response => {
        callback(response.data, true);
    }).catch(
        error => {
            if (error.response !== undefined) {
                if (HTTP_STATUS_CODE_401_UNAUTHORIZED === error.response.status) {
                    toast.error(ERROR_MESSAGE_401_UNAUTHORIZED)
                } else if (HTTP_STATUS_CODE_403_FORBIDDEN === error.response.status) {
                    toast.error(ERROR_MESSAGE_403_FORBIDDEN)
                } else {
                    //error.response.data
                }
            } else {
                toast.error("Check your internet connection or network connectivity issue between servers");
            }
            callback(null, false);
        })
}


export const StartSimulation = (connectionId, callback) => (dispatch) => {
    ServiceEngine.defaults.headers.common.ConnectionId =  connectionId;
    ServiceEngine.get(START_SIMULATION_ENDPOINT).then(response => {
        callback(response.data, true);
    }).catch(
        error => {
            if (error.response !== undefined) {
                if (HTTP_STATUS_CODE_401_UNAUTHORIZED === error.response.status) {
                    toast.error(ERROR_MESSAGE_401_UNAUTHORIZED)
                } else if (HTTP_STATUS_CODE_403_FORBIDDEN === error.response.status) {
                    toast.error(ERROR_MESSAGE_403_FORBIDDEN)
                } else {
                    //error.response.data
                }
            } else {
                toast.error("Check your internet connection or network connectivity issue between servers");
            }
            callback(null, false);
        })
}

export default SimulationServicesSlice.reducer
